import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from '../../../i18n/use-translation';
import { ActiveAuthForm } from '../../../store/auth/enum/active-auth-form';
import { ActiveModal } from '../../enums/active-modal';
import { LoginForm } from '../../organism/Auth/Login';
import { ChoosenRole } from '../../organism/Auth/Register/Components/ChoosenRole/ChoosenRole';
import { RegisterBlock } from '../../organism/Auth/Register/RegisterBlock';
import { ResetPasswordBlock } from '../../organism/Auth/ResetPasswordBlock/ResetPasswordBlock';
import { ChooseForm } from '../../organism/ChooseForm';
import { FeedbackForm } from '../../organism/FeedbackForm';
import { MobileMenu } from '../../organism/MobileMenu';
import { Tabs } from '../../organism/Tabs';
import { Card } from '../Card';
import { Footer } from '../Footer';
import { Header } from '../Header';
import { REGISTER_ROLES } from '../Header/roleConfig';
import { ModalType } from '../Modal/enum';
import { ModalContent } from '../Modal/Modal';
import { ShowModal } from '../Modal/Predefined/ShowModal';
import { titles, topTitles } from './header-titles';
import { useViewModel } from './hook/use-view-model';
import * as styles from './main_container.module.sass';

SwiperCore.use([Autoplay, Pagination, Navigation]);

export const MainContainer = (props: any) => {
  const { t, locale } = useTranslation();
  const {
    activeForm,
    changeTabHandler,
    modalCloseHandler,
    chooseRoleHandler,
    roleModalHandler,
    loginModalHandler,
    showFeedbackHandler,
    showModalHandler,
    modal,
  } = useViewModel();

  const tabs = {
    [ActiveAuthForm.LOGIN]: {
      title: t('sign_in'),
      content: <LoginForm />,
    },
    [ActiveAuthForm.REGISTER]: {
      title: t('register'),
      content: (
        <RegisterBlock>
          <ChoosenRole name="registerType" />
        </RegisterBlock>
      ),
    },
  };

  const mobileTabs = {
    [ActiveAuthForm.MENU]: {
      title: '',
      content: <MobileMenu topTitles={topTitles(locale, t)} titles={titles(locale, t)} />,
    },
    ...tabs,
  };

  const renderModal = (modal: ActiveModal) => {
    switch (modal) {
      case ActiveModal.ROLE:
        return (
          <ModalContent
            onBackdropClick={modalCloseHandler}
            onCloseClick={modalCloseHandler}
            type={ModalType.CENTER}
            buttonClassName={styles.registr_button}
          >
            <ChooseForm config={REGISTER_ROLES} onChooseHandler={chooseRoleHandler} />
          </ModalContent>
        );
      case ActiveModal.LOGIN:
        return (
          <ShowModal type={ModalType.SIDE} onClose={modalCloseHandler}>
            <Tabs tabs={tabs} activeTab={activeForm} onChooseHandler={changeTabHandler} />
          </ShowModal>
        );
      case ActiveModal.RESET_PASSWORD:
        return (
          <ShowModal type={ModalType.SIDE} onClose={modalCloseHandler}>
            <ResetPasswordBlock onSuccess={modalCloseHandler} />
          </ShowModal>
        );
      case ActiveModal.MENU:
        return (
          <ShowModal type={ModalType.SIDE} onClose={modalCloseHandler}>
            <Tabs tabs={mobileTabs} activeTab={activeForm} onChooseHandler={changeTabHandler} />
          </ShowModal>
        );
      case ActiveModal.FEEDBACK:
        return (
          <ShowModal type={ModalType.SIDE} onClose={modalCloseHandler}>
            <div className={styles.modal_header}>{t('feedback.title')}</div>
            <p className={styles.modal_subtitle}>{t('feedback.desc')}</p>

            <FeedbackForm />
          </ShowModal>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <link rel="shortcut icon" href="/public-assets/img/shared/favicon.ico" />
        <title>{t(props.general_title)}</title>
      </Helmet>
      <Header
        signModalHandler={loginModalHandler}
        roleModalHandler={roleModalHandler}
        showModalHandler={showModalHandler}
        titles={titles(locale, t)}
        topTitles={topTitles(locale, t)}
        placeholder={t('search_form')}
      />

      {props.children}

      <div className={styles.clients_section}>
        <Card className={classNames(styles.swiper_container)} heading_left>
          <h2>{t('section.ourPartners')}</h2>
        </Card>

        <Swiper
          className={styles.swiper}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1440: {
              slidesPerView: 4,
            },
          }}
          spaceBetween={30}
          grabCursor={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
        >
          <SwiperSlide>
            <a className={styles.main_shares_item} href="https://grippua.com.ua/" target="_blank">
              <img src="https://moniheal.net/m-public/homepage/633c3c3946409209111456.jpeg" className={styles.mocap_img} alt="" />
            </a>
          </SwiperSlide>

          <SwiperSlide>
            <a className={styles.main_shares_item} href="https://virus-stop.com.ua/" target="_blank">
              <img src="https://moniheal.net/m-public/homepage/6315ab9a26860902578519.jpeg" className={styles.mocap_img} alt="" />  
            </a>
          </SwiperSlide>

          <SwiperSlide>
            <a className={styles.main_shares_item} href="https://www.smartmama.com.ua/" target="_blank">
              <img src="https://moniheal.net/m-public/homepage/5ec5190a765fb682332190.jpg" className={styles.mocap_img} alt="" />
            </a>
          </SwiperSlide>

          <SwiperSlide>
            <a className={styles.main_shares_item} href="https://tabletki.ua/Витасед/1058945/" target="_blank">
              <img src="https://moniheal.net/m-public/homepage/633c3c6396a37490242156.jpg" className={styles.mocap_img} alt="" />
            </a>
          </SwiperSlide>
        </Swiper>
      </div>
      <Footer feedbackHandler={showFeedbackHandler} />
      {renderModal(modal)}
      <ToastContainer />
    </>
  );
};
